var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HTTPError } from "./consent.js";
/**
 * Creates an organization with the data corresponding to the payload
 */
export function createOrganization(client, payload) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield client.fetch(client.url.joinPath("/v1/api/create/company"), {
            method: "POST",
            body: JSON.stringify(payload),
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (!res.ok) {
            throw new HTTPError(res.status, { message: yield res.text(), res });
        }
        yield res.json();
    });
}
